import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Spinner, Container, Card, CardBody } from "reactstrap";
import ApiService from "../util/ApiService";
import googleCalendar from '../../../assets/images/google-calendar.png';

const IntegrationCallback = () => {
    const { integration } = useParams();
    const location = useLocation();
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const statusParam = params.get("status");
        const messageParam = params.get("message");

        if (statusParam === "success") {
            setStatus("success");
            setMessage(messageParam || "Integração realizada com sucesso.");
        } else {
            setStatus("error");
            setMessage(messageParam || "Não foi possível concluir a integração.");
        }
    }, [location.search]);

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <Card style={{ maxWidth: 1000, width: "100%", textAlign: "center", padding: 30 }}>
                <CardBody>
                    <img
                        src={googleCalendar}
                        alt="Google Calendar"
                        width={64}
                        style={{ marginBottom: 20 }}
                    />

                    <h4 className="mb-3">Integração com o Google Calendar</h4>

                    {status === "loading" && (
                        <>
                            <Spinner color="primary" />
                            <p className="mt-3">Estamos conectando sua conta, aguarde um instante...</p>
                        </>
                    )}

                    {status === "success" && (
                        <>
                            <div className="alert alert-success">
                                <strong>Sucesso!</strong> {message}
                            </div>
                            <p>
                                Sua conta foi conectada com êxito e seus plantões serão sincronizados automaticamente.
                                Você pode gerenciar a integração a qualquer momento na tela de configurações.
                            </p>
                        </>
                    )}

                    {status === "error" && (
                        <>
                            <div className="alert alert-danger">
                                <strong>Erro!</strong> {message}
                            </div>
                            <p>
                                Não foi possível concluir a integração. Por favor, verifique sua conta ou tente novamente.
                            </p>
                        </>
                    )}

                    <button
                        className="btn btn-success mt-3"
                        onClick={() => window.location.href = "/admin/integrations"}
                    >
                        <i className="fa fa-reply me-2"></i> Voltar para Integrações
                    </button>
                </CardBody>
            </Card>
        </Container>
    );
};

export default IntegrationCallback;
